import { SurveysTabBarIconWithBadge } from './SurveysTabBarIconWithBadge';
import { SurveyType, useGetSurveysTotalCountQuery } from '../../graphql/types.generated';

export const SurveysTabBarIconWithBadgeController = () => {
  const { data } = useGetSurveysTotalCountQuery({
    variables: {
      typeEquals: SurveyType.Wallet,
    },
  });
  return <SurveysTabBarIconWithBadge totalCount={data?.surveys.totalCount || 0} />;
};
